/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * This is the OpenAPI Document on Azure Functions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntityTagHeaderValue } from './EntityTagHeaderValue';
import {
    EntityTagHeaderValueFromJSON,
    EntityTagHeaderValueFromJSONTyped,
    EntityTagHeaderValueToJSON,
} from './EntityTagHeaderValue';

/**
 * 
 * @export
 * @interface FileContentResult
 */
export interface FileContentResult {
    /**
     * 
     * @type {Blob}
     * @memberof FileContentResult
     */
    fileContents?: Blob;
    /**
     * 
     * @type {string}
     * @memberof FileContentResult
     */
    contentType?: string;
    /**
     * 
     * @type {string}
     * @memberof FileContentResult
     */
    fileDownloadName?: string;
    /**
     * 
     * @type {Date}
     * @memberof FileContentResult
     */
    lastModified?: Date;
    /**
     * 
     * @type {EntityTagHeaderValue}
     * @memberof FileContentResult
     */
    entityTag?: EntityTagHeaderValue;
    /**
     * 
     * @type {boolean}
     * @memberof FileContentResult
     */
    enableRangeProcessing?: boolean;
}

/**
 * Check if a given object implements the FileContentResult interface.
 */
export function instanceOfFileContentResult(value: object): value is FileContentResult {
    return true;
}

export function FileContentResultFromJSON(json: any): FileContentResult {
    return FileContentResultFromJSONTyped(json, false);
}

export function FileContentResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileContentResult {
    if (json == null) {
        return json;
    }
    return {
        
        'fileContents': json['fileContents'] == null ? undefined : json['fileContents'],
        'contentType': json['contentType'] == null ? undefined : json['contentType'],
        'fileDownloadName': json['fileDownloadName'] == null ? undefined : json['fileDownloadName'],
        'lastModified': json['lastModified'] == null ? undefined : (new Date(json['lastModified'])),
        'entityTag': json['entityTag'] == null ? undefined : EntityTagHeaderValueFromJSON(json['entityTag']),
        'enableRangeProcessing': json['enableRangeProcessing'] == null ? undefined : json['enableRangeProcessing'],
    };
}

export function FileContentResultToJSON(value?: FileContentResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fileContents': value['fileContents'],
        'contentType': value['contentType'],
        'fileDownloadName': value['fileDownloadName'],
        'lastModified': value['lastModified'] == null ? undefined : ((value['lastModified']).toISOString()),
        'entityTag': EntityTagHeaderValueToJSON(value['entityTag']),
        'enableRangeProcessing': value['enableRangeProcessing'],
    };
}

